module.exports = __webpack_public_path__ + "assets/img/Shenzhen.bf3425d0.png";